import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';

import { GlobalErrorHandler } from './error/global.error.handler';
import { AcceptHeaderInterceptor } from './session/accept-header.interceptor';
import { SessionService } from './session/session.service';

import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEnGB from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import localeTh from '@angular/common/locales/th';
import localeZh from '@angular/common/locales/zh';
import { TranslateService } from '@ngx-translate/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { WINDOW } from './browser/window.support';


registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeEnGB);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeIt);
registerLocaleData(localeJa);
registerLocaleData(localeKo);
registerLocaleData(localeZh);
registerLocaleData(localePt);
registerLocaleData(localePl);
registerLocaleData(localeNl);
registerLocaleData(localeCs);
registerLocaleData(localeTh);
registerLocaleData(localeRu);


@NgModule({ declarations: [], imports: [CommonModule,
        MatNativeDateModule,
        OAuthModule.forRoot()], providers: [
        SessionService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AcceptHeaderInterceptor,
            multi: true
        },
        provideAppInitializer(() => {
        const initializerFn = (initTranslation)(inject(TranslateService));
        return initializerFn();
      }),
        provideAppInitializer(() => {
        const initializerFn = (initSession)(inject(SessionService));
        return initializerFn();
      }),
        {
            provide: LOCALE_ID,
            useFactory: getCurrentLocale,
        },
        {
            provide: WINDOW,
            useValue: window
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}

function initSession(sessionService: SessionService): () => Promise<void> {
  sessionService.initTimer();
  return async () => {
    await sessionService.loadPromise();
  };
}

function initTranslation(translate: TranslateService): () => Promise<void> {
  return async () => {
    await translate.use(getCurrentLocale()).toPromise();
  };
}

function getCurrentLocale(): string {
  const userLang = navigator.language;
  let defaultLocale = 'en';
  if (userLang && userLang.startsWith('de')) {
    defaultLocale = 'de';
  }
  return localStorage.getItem('Language') || defaultLocale;
}
